/* ==========================================================================
   MayaTrendy 2.0 — mt-app.js
   Amélioration progressive uniquement : sans JavaScript, toutes les pages
   restent utilisables (formulaire complet, onglets empilés, audio natif,
   soumission classique du panier).
   Aucune dépendance, aucun script tiers, aucun appel réseau externe.
   ========================================================================== */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ------------------------------------------------------------------ *
   * 1. « Mira cómo nace » — onglets par étapes
   * ------------------------------------------------------------------ */
  function initNace() {
    var roots = document.querySelectorAll("[data-mt-nace]");
    Array.prototype.forEach.call(roots, function (root) {
      var tabs = root.querySelectorAll("[data-mt-nace-tab]");
      var panels = root.querySelectorAll("[data-mt-nace-panel]");
      if (!tabs.length || !panels.length) return;
      root.classList.add("is-js");
      root.setAttribute("role", "tablist");

      function activate(key, focus) {
        Array.prototype.forEach.call(tabs, function (t) {
          var on = t.getAttribute("data-mt-nace-tab") === key;
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-selected", on ? "true" : "false");
          t.setAttribute("tabindex", on ? "0" : "-1");
          if (on && focus) t.focus();
        });
        Array.prototype.forEach.call(panels, function (p) {
          var on = p.getAttribute("data-mt-nace-panel") === key;
          p.classList.toggle("is-active", on);
          p.hidden = !on;
        });
      }

      Array.prototype.forEach.call(tabs, function (t, i) {
        t.setAttribute("role", "tab");
        t.addEventListener("click", function () { activate(t.getAttribute("data-mt-nace-tab"), false); });
        t.addEventListener("keydown", function (e) {
          var next = null;
          if (e.key === "ArrowRight" || e.key === "ArrowDown") next = tabs[(i + 1) % tabs.length];
          if (e.key === "ArrowLeft" || e.key === "ArrowUp") next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === "Home") next = tabs[0];
          if (e.key === "End") next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); activate(next.getAttribute("data-mt-nace-tab"), true); }
        });
      });

      activate(tabs[0].getAttribute("data-mt-nace-tab"), false);
    });
  }

  /* ------------------------------------------------------------------ *
   * 2. Configurateur — étapes, validation, résumé, prix
   * ------------------------------------------------------------------ */
  function initConfigurator() {
    var roots = document.querySelectorAll("[data-mt-config]");
    Array.prototype.forEach.call(roots, function (root) {
      var steps = root.querySelectorAll("[data-mt-step]");
      if (!steps.length) return;
      var progress = root.querySelector("[data-mt-progress]");
      var summary = root.querySelector("[data-mt-summary]");
      var stepLabel = root.querySelector("[data-mt-step-label]");
      var select = root.querySelector("[data-mt-variant-select]");
      var priceOut = document.querySelectorAll("[data-mt-price-out]");
      var formatProp = root.querySelector("[data-mt-format-prop]");
      var picker = root.querySelector("[data-mt-format-picker]");
      var form = root.closest("form") || root.querySelector("form");
      var index = 0;

      root.classList.add("is-js");
      if (picker) picker.classList.add("is-js");

      function money(cents) {
        var value = (cents / 100).toFixed(2);
        return value.replace(".", ",") + " €";
      }

      function render() {
        Array.prototype.forEach.call(steps, function (s, i) {
          s.classList.toggle("is-current", i === index);
        });
        if (progress) progress.style.setProperty("--mt-progress", ((index + 1) / steps.length * 100) + "%");
        if (stepLabel) stepLabel.textContent = (index + 1) + "/" + steps.length;
        buildSummary();
        if (!reduceMotion) {
          var legend = steps[index].querySelector("legend, h3");
          if (legend) legend.scrollIntoView({ block: "nearest" });
        }
      }

      function fieldLabel(el) {
        var wrap = el.closest(".mt-field");
        if (wrap) {
          var l = wrap.querySelector("label, .mt-field__label");
          if (l) return l.textContent.replace(/\*/g, "").trim();
        }
        var esc = el.closest(".mt-choice");
        if (esc) {
          var sl = esc.querySelector(".mt-choice__label strong");
          if (sl) return sl.textContent.trim();
        }
        return el.name.replace("properties[", "").replace("]", "");
      }

      function buildSummary() {
        if (!summary || !form) return;
        var rows = [];
        var data = new FormData(form);
        data.forEach(function (value, key) {
          if (key === "id" || key === "quantity" || !String(value).trim()) return;
          var clean = key.replace("properties[", "").replace("]", "");
          if (clean.charAt(0) === "_") return;
          rows.push([clean, String(value).trim()]);
        });
        if (select && select.selectedIndex > -1) {
          rows.unshift([select.options[select.selectedIndex].getAttribute("data-label") || "Formato", select.options[select.selectedIndex].text.trim()]);
        }
        summary.innerHTML = rows.map(function (r) {
          return "<div><dt>" + r[0] + "</dt><dd>" + r[1].replace(/</g, "&lt;") + "</dd></div>";
        }).join("");
        if (!rows.length) summary.innerHTML = "<div><dt>Sin datos todavía</dt><dd>—</dd></div>";
      }

      function validateStep(i) {
        var ok = true;
        var fields = steps[i].querySelectorAll("input, select, textarea");
        Array.prototype.forEach.call(fields, function (f) {
          if (f.disabled) return;
          if (!f.checkValidity()) {
            ok = false;
            f.setAttribute("aria-invalid", "true");
          } else {
            f.removeAttribute("aria-invalid");
          }
        });
        var firstInvalid = steps[i].querySelector('[aria-invalid="true"]');
        if (firstInvalid) {
          firstInvalid.focus({ preventScroll: true });
          var legend = steps[i].querySelector("legend, h3");
          if (legend) legend.scrollIntoView({ block: "start", behavior: reduceMotion ? "auto" : "smooth" });
        }
        return ok;
      }

      /* Valide TOUTES les étapes (la barre collante peut soumettre depuis
         n'importe quelle étape) et ramène l'utilisateur à la première erreur. */
      function validateAll() {
        for (var i = 0; i < steps.length; i++) {
          if (!validateStep(i)) {
            if (i !== index) { index = i; render(); }
            validateStep(i);
            return false;
          }
        }
        return true;
      }

      Array.prototype.forEach.call(root.querySelectorAll("[data-mt-next]"), function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          if (!validateStep(index)) return;
          if (index < steps.length - 1) { index++; render(); }
        });
      });
      Array.prototype.forEach.call(root.querySelectorAll("[data-mt-prev]"), function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          if (index > 0) { index--; render(); }
        });
      });

      // Synchronise les choix de format (radios) avec le <select name="id"> natif
      Array.prototype.forEach.call(root.querySelectorAll("[data-mt-variant]"), function (radio) {
        radio.addEventListener("change", function () {
          if (select) {
            select.value = radio.value;
            select.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      });

      function updatePrice() {
        if (!select) return;
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        var cents = parseInt(opt.getAttribute("data-price") || "0", 10);
        Array.prototype.forEach.call(priceOut, function (el) { el.textContent = money(cents); });
        if (formatProp) formatProp.value = opt.text.split(" — ")[0].trim();
      }
      if (select) { select.addEventListener("change", updatePrice); updatePrice(); }
      if (form) {
        form.addEventListener("change", buildSummary);
        form.addEventListener("input", buildSummary);
        form.addEventListener("submit", function (e) {
          if (!validateAll()) { e.preventDefault(); return; }
          var submit = form.querySelector('[type="submit"]');
          if (submit && !reduceMotion) submit.setAttribute("aria-busy", "true");
        });
      }

      render();
    });
  }

  /* ------------------------------------------------------------------ *
   * 3. Dépôt de fichiers (démonstration) — validation client + résumé
   *    Aucun envoi réel : l'architecture cible passe par une URL signée
   *    vers un stockage privé (voir notice dans le configurateur).
   * ------------------------------------------------------------------ */
  var LIMITS = {
    "image/jpeg": 20, "image/png": 20, "application/pdf": 25,
    "audio/mpeg": 50, "audio/wav": 50, "audio/x-wav": 50,
    "video/mp4": 200, "video/quicktime": 200
  };

  function initUpload() {
    var roots = document.querySelectorAll("[data-mt-upload]");
    Array.prototype.forEach.call(roots, function (root) {
      var input = root.querySelector('input[type="file"]');
      var list = root.querySelector("[data-mt-upload-list]");
      var sink = root.querySelector("[data-mt-upload-summary]");
      var status = root.querySelector("[data-mt-upload-status]");
      if (!input || !list) return;
      var accept = (input.getAttribute("accept") || "").split(",").map(function (s) { return s.trim().toLowerCase(); });

      input.addEventListener("change", function () {
        var files = Array.prototype.slice.call(input.files || []);
        var lines = [];
        var summary = [];
        var bytes = 0;
        files.forEach(function (f) {
          var ext = (f.name.split(".").pop() || "").toLowerCase();
          var typeOk = LIMITS[f.type] !== undefined || accept.indexOf("." + ext) > -1;
          var max = LIMITS[f.type] || 25;
          var mb = f.size / 1048576;
          var ok = typeOk && mb <= max;
          bytes += f.size;
          summary.push(f.name + " (" + mb.toFixed(1) + " Mo)");
          lines.push(
            '<li class="' + (ok ? "" : "mt-drop__warn") + '"><span>' +
            f.name.replace(/</g, "&lt;") + "</span><span>" +
            mb.toFixed(1) + " Mo " + (ok ? "✓" : "✕ > " + max + " Mo") + "</span></li>"
          );
        });
        list.innerHTML = lines.join("");
        if (sink) sink.value = summary.join(" | ");
        if (status) {
          status.textContent = files.length
            ? files.length + " fichier(s) sélectionné(s) — total " + (bytes / 1048576).toFixed(1) + " Mo"
            : "";
        }
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * 4. Barre collante mobile : masquage quand le formulaire est visible
   * ------------------------------------------------------------------ */
  function initSticky() {
    var bars = document.querySelectorAll("[data-mt-sticky]");
    if (!bars.length || !("IntersectionObserver" in window)) return;
    Array.prototype.forEach.call(bars, function (bar) {
      var target = document.querySelector(bar.getAttribute("data-mt-sticky"));
      if (!target) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle("is-hidden", entry.isIntersecting);
          bar.style.visibility = entry.isIntersecting ? "hidden" : "";
        });
      }, { rootMargin: "-20% 0px -30% 0px" });
      io.observe(target);
    });
  }

  function boot() {
    initNace();
    initConfigurator();
    initUpload();
    initSticky();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
